export const SET_SCRAPED_INFORMATION = 'SET_SCRAPED_INFORMATION'
export const SET_SCRAPER = 'SET_SCRAPER'
